import {GeneralAction} from '../../../@types/actions';
import {GET_EVENT} from '../../../constants/PlayerConstants';

export const GetEventPlayersAction = (eventId: number): GeneralAction<{ eventId: number }> => ({
    type: GET_EVENT,
    payload: {eventId}
});